import {getLightnessSign} from '@sail/utils';
import {COLORS} from 'src/v2/util/color';
import {absurd} from 'src/utils/absurd';

export type TextType = 'primary' | 'subdued' | 'disabled';

/**
 * Determines the appropriate text color for accessibility based on background color.
 * Uses WCAG-compliant contrast ratios via getLightnessSign.
 *
 * @param backgroundColor - The background color to analyze
 * @param textType - The type of text (primary, secondary, disabled)
 * @returns The appropriate text color for accessibility
 */
export function getAccessibleTextColor(
  backgroundColor: string,
  textType: TextType = 'primary',
): string {
  const lightnessSign = getLightnessSign(backgroundColor);

  // lightnessSign === 1 means use light text (dark background)
  // lightnessSign === -1 means use dark text (light background)

  switch (textType) {
    case 'primary':
      return lightnessSign === 1
        ? COLORS.textPrimaryOnDark
        : COLORS.textPrimary;

    case 'subdued':
      return lightnessSign === 1
        ? COLORS.textSubduedOnDark
        : COLORS.textSubduedOnLight;

    case 'disabled':
      return lightnessSign === 1
        ? COLORS.textDisabledOnDark
        : COLORS.textDisabledOnLight;

    default:
      return absurd(textType);
  }
}
